// CWJ- CODE FROM THEME.LIQUID
document.addEventListener("DOMContentLoaded", function () {
        const toggleMenu = document.querySelector(".toggle-menu");
        const megaMenu = document.querySelector("nav.header__inline-menu.mega-menu");
        if (!toggleMenu || !megaMenu) return;
        toggleMenu.addEventListener("click", function () {
          megaMenu.classList.toggle("menu-open");
          toggleMenu.classList.toggle("active");
        });
      });

      document.addEventListener('DOMContentLoaded', function () {
        // ✅ Override Shopify's header-drawer close behaviour entirely
        const headerDrawerEl = document.querySelector('header-drawer');
        if (headerDrawerEl) {
          headerDrawerEl.addEventListener(
            'click',
            function (e) {
              if (!e.target.closest('summary')) {
                e.stopImmediatePropagation();
                e.stopPropagation();
              }
            },
            true
          ); // ✅ useCapture: true — fires BEFORE Shopify's own listener
        }

        const drawers = document.querySelectorAll('.mega-drawer');
        drawers.forEach(function (drawer) {
          const primaryItems = drawer.querySelectorAll('.mega-drawer__primary-item');
          const primaryButtons = drawer.querySelectorAll('.mega-drawer__primary-link[data-target]');
          const secondaryPanels = drawer.querySelectorAll('.mega-drawer__secondary-panel');

          function clearAll() {
            drawer.querySelectorAll('.mega-drawer__primary-link').forEach((btn) => btn.classList.remove('is-active'));
            secondaryPanels.forEach(function (panel) {
              panel.classList.remove('is-active');
              panel
                .querySelectorAll('.mega-drawer__secondary-link')
                .forEach((btn) => btn.classList.remove('is-active'));
              panel.querySelectorAll('.mega-drawer__tertiary-panel').forEach((gp) => gp.classList.remove('is-active'));
            });
          }

          function openPrimary(index) {
            clearAll();
            const primaryBtn = drawer.querySelector('.mega-drawer__primary-link[data-target="' + index + '"]');
            const secondaryPanel = drawer.querySelector('.mega-drawer__secondary-panel[data-panel="' + index + '"]');
            if (primaryBtn) primaryBtn.classList.add('is-active');
            if (secondaryPanel && secondaryPanel.querySelector('.mega-drawer__secondary-link')) {
              secondaryPanel.classList.add('is-active');
            }
          }

          function openSecondary(panel, childIndex) {
            panel.querySelectorAll('.mega-drawer__secondary-link').forEach((btn) => btn.classList.remove('is-active'));
            panel.querySelectorAll('.mega-drawer__tertiary-panel').forEach((gp) => gp.classList.remove('is-active'));

            const currentChildBtn = panel.querySelector(
              '.mega-drawer__secondary-link[data-child-target="' + childIndex + '"]'
            );
            if (currentChildBtn) currentChildBtn.classList.add('is-active');

            const targetGrandPanel = panel.querySelector(
              '.mega-drawer__tertiary-panel[data-child-panel="' + childIndex + '"]'
            );
            if (targetGrandPanel && targetGrandPanel.querySelector('.mega-drawer__tertiary-link')) {
              targetGrandPanel.classList.add('is-active');
            }
          }

          primaryItems.forEach(function (item) {
            item.addEventListener('mouseenter', function () {
              const index = item.dataset.index;
              const hasChildren = item.classList.contains('has-children');
              if (hasChildren) {
                openPrimary(index);
              } else {
                clearAll();
              }
            });
          });

          primaryButtons.forEach(function (btn) {
            btn.addEventListener('focus', () => openPrimary(btn.dataset.target));
            btn.addEventListener(
              'click',
              function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();
                openPrimary(btn.dataset.target);
              },
              true
            );
          });

          secondaryPanels.forEach(function (panel) {
            const secondaryItems = panel.querySelectorAll('.mega-drawer__secondary-item');

            secondaryItems.forEach(function (item) {
              item.addEventListener('mouseenter', function () {
                const hasChildren = item.classList.contains('has-children');
                const childIndex = item.dataset.childIndex;
                if (hasChildren) {
                  openSecondary(panel, childIndex);
                } else {
                  panel
                    .querySelectorAll('.mega-drawer__secondary-link')
                    .forEach((btn) => btn.classList.remove('is-active'));
                  panel
                    .querySelectorAll('.mega-drawer__tertiary-panel')
                    .forEach((gp) => gp.classList.remove('is-active'));
                }
              });
            });

            panel.querySelectorAll('.mega-drawer__secondary-link[data-child-target]').forEach(function (btn) {
              btn.addEventListener('mouseenter', () => openSecondary(panel, btn.dataset.childTarget));
              btn.addEventListener('focus', () => openSecondary(panel, btn.dataset.childTarget));
              btn.addEventListener(
                'click',
                function (e) {
                  e.preventDefault();
                  e.stopImmediatePropagation();
                  e.stopPropagation();
                  openSecondary(panel, btn.dataset.childTarget);
                },
                true
              );
            });

            panel.querySelectorAll('.mega-drawer__secondary-link:not([data-child-target])').forEach(function (link) {
              link.addEventListener(
                'click',
                function (e) {
                  e.stopImmediatePropagation();
                  e.stopPropagation();
                },
                true
              );
            });
          });

          drawer.querySelectorAll('.mega-drawer__tertiary-link').forEach(function (link) {
            link.addEventListener(
              'click',
              function (e) {
                e.stopImmediatePropagation();
                e.stopPropagation();
              },
              true
            );
          });

          drawer.addEventListener('mouseleave', clearAll);
        });
      });
      
      document.addEventListener('click', function (e) {
        const closeBtn = e.target.closest('.mobile-facets__close');

        if (closeBtn) {
          const details = closeBtn.closest('details.mobile-facets__disclosure');

          if (details) {
            details.removeAttribute('open');
            document.body.classList.remove('overflow-hidden-mobile');
          }
        }
      });
      document.addEventListener("click", function (e) {

        const label = e.target.closest(".facet-filters__label label");

        if (!label) return;

        e.preventDefault();

        const wrapper = label.closest(".facet-filters");
        const select = wrapper.querySelector(".select");

        if (select) {
          select.classList.toggle("active");
        }

      });
      document.addEventListener('DOMContentLoaded', function () {
        const accordions = document.querySelectorAll('.accordion details');

        accordions.forEach((item) => {
          item.addEventListener('toggle', function () {
            if (this.open) {
              accordions.forEach((other) => {
                if (other !== this) {
                  other.removeAttribute('open');
                }
              });
            }
          });
        });
      });
      const toggles = document.querySelectorAll('.nav-toggle');

      toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          toggle.classList.toggle('active');

          // Target multiple menus
          const secondaryMenu = document.querySelector('.secondary-menu-list__items');
          const blogFilter = document.querySelector('.blog-filter-nav .blog-filter');

          if (secondaryMenu) {
            secondaryMenu.classList.toggle('active');
          }

          if (blogFilter) {
            blogFilter.classList.toggle('active');
          }
        });
      });
